import { render } from "./NewsHero.vue?vue&type=template&id=18698599&scoped=true"
import script from "./NewsHero.vue?vue&type=script&lang=js"
export * from "./NewsHero.vue?vue&type=script&lang=js"

import "./NewsHero.vue?vue&type=style&index=0&id=18698599&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18698599"]])

export default __exports__